export class Microsoft365EntitySelection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "Microsoft365SelectionMode",
            "format": ""
        },
        {
            "name": "includeIds",
            "baseName": "includeIds",
            "type": "Array<Microsoft365FilterSelectionRef>",
            "format": ""
        },
        {
            "name": "excludeIds",
            "baseName": "excludeIds",
            "type": "Array<Microsoft365FilterSelectionRef>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365EntitySelection.attributeTypeMap;
    }
    constructor() {
    }
}
